import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach the correct token based on the route
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const adminToken = localStorage.getItem("climomax_admin_token");
  const custToken = localStorage.getItem("climomax_customer_token");
  if (url.startsWith("/admin") || url.startsWith("/auth")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (url.startsWith("/customer")) {
    if (custToken) config.headers.Authorization = `Bearer ${custToken}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
